import { render, staticRenderFns } from "./SuperDocSearchBar.vue?vue&type=template&id=8e2bd2a6&scoped=true"
import script from "./SuperDocSearchBar.vue?vue&type=script&lang=js"
export * from "./SuperDocSearchBar.vue?vue&type=script&lang=js"
import style0 from "./SuperDocSearchBar.vue?vue&type=style&index=0&id=8e2bd2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2bd2a6",
  null
  
)

export default component.exports